import { CheckboxProps, Checkbox } from "antd";

interface IProps extends CheckboxProps {
  id: string;
}

/**
 * @author traj3ctory
 * @function @AppCheckBox
 **/

const AppCheckBox = ({ id, ...props }: IProps) => {
  return <Checkbox id={id} {...props} />;
};

const AppCheckBoxGroup = Checkbox.Group;

export { AppCheckBox, AppCheckBoxGroup };
